import { render, staticRenderFns } from "./FolderSettingsPopUp.vue?vue&type=template&id=cf1b7532&scoped=true"
import script from "./FolderSettingsPopUp.vue?vue&type=script&lang=js"
export * from "./FolderSettingsPopUp.vue?vue&type=script&lang=js"
import style0 from "./FolderSettingsPopUp.vue?vue&type=style&index=0&id=cf1b7532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1b7532",
  null
  
)

export default component.exports